import React from "react";

import { useNavigate, useTranslation } from "utils";

import { ALL_FIELDS_MAP_VIEW_ROUTE, ALL_FIELDS_ROUTE, ALL_FIELDS_TABLE_VIEW_ROUTE } from "consts";

import { FieldViewModeAnnouncement } from "pages/app/all-field-view/components/FieldViewModeAnnouncement";

type ViewMode = "timeline" | "table" | "map";

type ViewModeConfig = {
  key: ViewMode;
  labelKey: string;
  label: string;
  path: string;
};

const VIEW_MODES: ViewModeConfig[] = [
  { key: "timeline", labelKey: "viewSwitcher.timeline", label: "Timeline", path: ALL_FIELDS_ROUTE },
  { key: "table", labelKey: "viewSwitcher.table", label: "Table", path: ALL_FIELDS_TABLE_VIEW_ROUTE },
  { key: "map", labelKey: "viewSwitcher.map", label: "Map", path: ALL_FIELDS_MAP_VIEW_ROUTE },
];

type FieldViewModeSwitcherProps = {
  activeMode: ViewMode;
};

export const FieldViewModeSwitcher = ({ activeMode }: FieldViewModeSwitcherProps) => {
  const { t } = useTranslation("allFieldView");
  const navigate = useNavigate();

  return (
    // The timeline is where farmers land, so that is the only view the other two need announcing from — the
    // Table tab is no longer conditionally gated, so there's nothing else to check eligibility against.
    <FieldViewModeAnnouncement isEligible={activeMode === "timeline"} onTryItOut={() => navigate(ALL_FIELDS_TABLE_VIEW_ROUTE)}>
      <div className="field-view-mode-switcher">
        {VIEW_MODES.map(({ key, labelKey, label, path }) => (
          <button key={key} type="button" className={`field-view-mode-btn${activeMode === key ? " active" : ""}`} onClick={() => navigate(path)}>
            {t(labelKey, { defaultValue: label })}
          </button>
        ))}
      </div>
    </FieldViewModeAnnouncement>
  );
};
